import { render, staticRenderFns } from "./QuickCompanySetting.vue?vue&type=template&id=702d7124&scoped=true"
import script from "./QuickCompanySetting.vue?vue&type=script&lang=js"
export * from "./QuickCompanySetting.vue?vue&type=script&lang=js"
import style0 from "./QuickCompanySetting.vue?vue&type=style&index=0&id=702d7124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702d7124",
  null
  
)

export default component.exports